<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <router-view />
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import MainView from '@/views/mainview/index.vue'


export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  created() {
    this.$router.push('/')
  },
  methods: {

  },
  mounted() {
  // 获取当前页面的 URL
  const currentUrl = window.location.href;
  // 判断是否有哈希值且哈希值对应路由存在
  if (currentUrl.includes('#') && this.$router.getRoutes().some(route => route.path === currentUrl.split('#')[1])) {
    this.$router.push(currentUrl.split('#')[1]);
  } else {
    const currentRoute = localStorage.getItem('currentRoute');
    if (currentRoute) {
      this.$router.push(currentRoute);
      localStorage.removeItem('currentRoute');
    }
  }
}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
